const fragmentCategory = `
  fragment CategoryFields on CategoryTree {
    id
    name
    uid
    url_path
    url_suffix
    category_thumbnail_image
  }
`;

export default `
  query categoryList($filters: CategoryFilterInput, $pageSize: Int = 20) {
    categoryList(filters: $filters, pageSize: $pageSize) {
      ...CategoryFields
      children {
        ...CategoryFields
        children {
          ...CategoryFields
          children {
            ...CategoryFields
          }
        }
      }
    }
  }
  ${fragmentCategory}
`;
